import { render, staticRenderFns } from "./ParentRegistrationForm.vue?vue&type=template&id=b7198344&scoped=true&"
import script from "./ParentRegistrationForm.vue?vue&type=script&lang=ts&"
export * from "./ParentRegistrationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ParentRegistrationForm.vue?vue&type=style&index=0&id=b7198344&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7198344",
  null
  
)

export default component.exports